import { atom } from 'jotai';

export const campaignNotificationNumberAtom = atom<number>(0);

export const isInitialLoginCampaignNotification = atom<boolean>(false);
